document.addEventListener('DOMContentLoaded', function () {
  // faq accordion start here
  var acc = document.getElementsByClassName("accordion1");
  var i;

  for (i = 0; i < acc.length; i++) {
    acc[i].addEventListener("click", function () {
      this.classList.toggle("active");
      var panel = this.nextElementSibling;
      if (panel.style.maxHeight) {
        panel.style.maxHeight = null;
      } else {
        panel.style.maxHeight = panel.scrollHeight + "px";
      }
    });
  }
});

// faq accordion code end here
document.addEventListener('click', function (event) {
  if (!window.matchMedia('(max-width: 989px)').matches) return;

  var reveal = event.target.closest('[data-team-card-reveal]');
  if (reveal) {
    reveal.closest('details[open]').open = false;
  }
});

$('.feature_atc').click(function () {
  var data_id = $(this).parents('.feature-pro_reapeated').find('.feature_right').find('form').find('.product_feature_variant option:selected').val();
  var cartService = window.Express && window.Express.cartService;

  if (!cartService || typeof cartService.addItem !== 'function') {
    console.error('Cart service is unavailable.');
    return;
  }

  cartService.addItem({ id: data_id, quantity: 1 })
    .then(function () {
      window.location.href = "/cart";
    })
    .catch(function (error) {
      console.error('Unable to add product to cart', error);
    });
})


document.addEventListener('DOMContentLoaded', function () {
  const toggles = document.querySelectorAll('.accordion-toggle');
  toggles.forEach((toggle) => {
    toggle.addEventListener('click', () => {
      const content = toggle.nextElementSibling;
      const isActive = toggle.classList.contains('active');

      toggles.forEach((t) => {
        t.classList.remove('active');
        t.nextElementSibling.style.maxHeight = null;
      });

      if (!isActive) {
        toggle.classList.add('active');
        content.style.maxHeight = content.scrollHeight + 'px';
      }
    });
  });
});

document.addEventListener('DOMContentLoaded', function () {
  // Feature content homepage mobile slider code start here
  if (window.NativeCarousel) {
    new window.NativeCarousel('.feature_mob_slider', {
      mobileOnly: true,
      mobileMax: 749,
      desktopSlidesToShow: 3,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dots: false,
      autoplay: true,
      autoplaySpeed: 1500
    });
  }
  // Feature content homepage mobile slider code end here
});

const stickyPills = document.querySelector('.sticky-pills-vertical');
const trigger = document.getElementById('key-features'); // Trigger point
const pillButtons = document.querySelectorAll('.pill-nav-vertical button');
const sectionIds = ['key-features', 'comparison', 'inclusions', 'checklist', 'process', 'faq'];

pillButtons.forEach((btn) => {
  btn.addEventListener('click', () => {
    const target = document.getElementById(btn.dataset.target);
    if (target) {
      window.scrollTo({
        top: target.offsetTop - 80,
        behavior: 'smooth',
      });
    }
  });
});


document.addEventListener('DOMContentLoaded', function () {
  new Swiper('.fixturesSwiper', {
    loop: true,
    slidesPerView: 1,
    spaceBetween: 20,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
    },
    breakpoints: {
      768: { slidesPerView: 2 },
      1024: { slidesPerView: 3 },
    },
  });
  document.querySelectorAll('.lightbox-trigger').forEach((card) => {
    card.addEventListener('click', function () {
      const imgSrc = this.dataset.image;
      const instance = basicLightbox.create(
        `<img src="${imgSrc}" style="max-width: 90vw; max-height: 90vh;" alt="Fixture Image">`
      );
      instance.show();
    });
  });
});


const scrollTopBtn = document.getElementById('scrollTopBtn');

if (scrollTopBtn) {
  window.addEventListener('scroll', () => {
    scrollTopBtn.style.display = window.scrollY > 300 ? 'block' : 'none';
  });
  scrollTopBtn.addEventListener('click', () => {
    window.scrollTo({ top: 600, behavior: 'smooth' });
  });
}


jQuery(document).ready(function () {
  $('[data-fancybox="gallery"]').fancybox({
    loop: true,
    infobar: false,
    arrows: true,
    buttons: ['zoom', 'thumbs', 'close'],
    protect: false,
  });

  $().fancybox({
    selector: '[data-fancybox^="variant-media-"]',
    loop: true,
    infobar: false,
    arrows: true,
    buttons: ['close'],
    thumbs: false,
    protect: false,
  });

  $('[data-fancybox="image"]').fancybox({
    buttons: ['close'],
    loop: true,
    arrows: true,
    protect: false,
    counter: false,
  });

  $('[data-fancybox^="floor-plans-"]').fancybox({
    buttons: ['zoom', 'fullScreen', 'close'],
    loop: false,
    arrows: true,
    protect: true,
  });
});


jQuery(document).ready(function () {
  $(document).on('click', '.read-more', function () {
    $('.read_more_content').fadeIn();
    $(this).hide();
    $('.read-less').show();
  });
  $(document).on('click', '.read-less', function () {
    $('.read_more_content').fadeOut();
    $(this).hide();
    $('.read-more').show();
  });
});

$(document).ready(function () {
  var first_val, sec_val;
  $('.select1').change(function () {
    first_val = $(this).val();
  });
  $('.select2').change(function () {
    sec_val = $(this).val();
    var first_sel_val = $('.select1 option:selected').val();
    // console.log(first_sel_val)
    // console.log(sec_val);
    var combo = first_sel_val + ' / ' + sec_val;
    // console.log(combo)
    var main_sel = $(this)
      .parents('.feature-pro_reapeated')
      .find('.product_feature_variant option')
      .each(function () {
        var each_val = $(this).text();
        // console.log(each_val)
        if (combo.indexOf(each_val) > -1) {
          var this_val = $(this).val();
          $(this).parents('.feature-pro_reapeated').find('.product_feature_variant').val(this_val); // Set a specific value
          $(this).parents('.feature-pro_reapeated').find('.product_feature_variant').trigger('change');
        }
      });

    // var main_sel = main_sel.trim();
    if (combo.indexOf(main_sel) > -1) {
      // console.log('yes')
      var valueee = $(this).parents('.feature-pro_reapeated').find('.product_feature_variant').val();
      // console.log(valueee)
    }
  });
});

if ($('.feature-pro_reapeated .swatch-element.sec_option').length) {
  $('.swatch-element.color input').click(function () {
    $('.swatch-element.color label').removeClass('active');

    var color_val = $(this).val();
    $(this).parents('label').addClass('active');

    var sec_val = $('.swatch-element.sec_option input:checked').val();
    var combo = color_val + ' / ' + sec_val;
    // console.log(combo);
    var select = $(this).parents('form').find('.product_feature_variant');

    select.find('option').each(function () {
      var mainsel = $(this).text().trim();
      // console.log(mainsel)
      if (combo == mainsel) {
        // console.log('yes');
        select.find('option:contains("' + combo + '")').prop('selected', true);

        // Trigger a change event on select box to select the specified option
        select.trigger('change');
        var data_price = $(this).parents('form').find('.product_feature_variant option:selected').attr('data-price');
        $(this).parents('.feature-pro_reapeated').find('.featurepro_price').html(data_price);
        var sel_val = $(this).val();
        // console.log(sel_val);
      }
    });
  });
} else {
  $('.swatch-element.color input').click(function () {
    $('.swatch-element.color label').removeClass('active');

    var color_val = $(this).val();
    $(this).parents('label').addClass('active');

    var select = $(this).parents('form').find('.product_feature_variant');

    select.find('option').each(function () {
      var mainsel = $(this).text().trim();
      // console.log(mainsel)
      if (color_val == mainsel) {
        // console.log('yes');
        select.find('option:contains("' + color_val + '")').prop('selected', true);

        // Trigger a change event on select box to select the specified option
        select.trigger('change');
        var data_price = $(this).parents('form').find('.product_feature_variant option:selected').attr('data-price');
        $(this).parents('.feature-pro_reapeated').find('.featurepro_price').html(data_price);
        var sel_val = $(this).val();
        // console.log(sel_val);
      }
    });
  });
}

if ($('.feature-pro_reapeated .swatch-element.color').length) {
  $('.swatch-element.sec_option input').click(function () {
    $('.swatch-element.sec_option label').removeClass('active');

    var sec_val = $(this).val();
    $(this).parents('label').addClass('active');
    var color_val = $(this).parents('.feature_right').find('.swatch-element.color input:checked').val();

    var combo = color_val + ' / ' + sec_val;

    var select = $(this).parents('form').find('.product_feature_variant');

    select.find('option').each(function () {
      var mainsel = $(this).text().trim();
      // console.log(mainsel)
      if (combo == mainsel) {
        // console.log('yes');
        select.find('option:contains("' + combo + '")').prop('selected', true);

        // Trigger a change event on select box to select the specified option
        select.trigger('change');
        var data_price = $(this).parents('form').find('.product_feature_variant option:selected').attr('data-price');
        $(this).parents('.feature-pro_reapeated').find('.featurepro_price').html(data_price);
        var sel_val = $(this).val();
        // console.log(sel_val);
      }
    });
  });
} else {
  $('.swatch-element.sec_option input').click(function () {
    $('.swatch-element.sec_option label').removeClass('active');

    var sec_val = $(this).val();
    $(this).parents('label').addClass('active');

    var select = $(this).parents('form').find('.product_feature_variant');

    select.find('option').each(function () {
      var mainsel = $(this).text().trim();
      // console.log(mainsel)
      if (sec_val == mainsel) {
        // console.log('yes');
        select.find('option:contains("' + sec_val + '")').prop('selected', true);

        // Trigger a change event on select box to select the specified option
        select.trigger('change');
        var data_price = $(this).parents('form').find('.product_feature_variant option:selected').attr('data-price');
        $(this).parents('.feature-pro_reapeated').find('.featurepro_price').html(data_price);
        var sel_val = $(this).val();
        // console.log(sel_val);
      }
    });
  });
}


jQuery(document).ready(function () {
  jQuery('.logo-carousel')
    .not('.slick-initialized')
    .slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      infinite: true,
      autoplay: true,
      autoplaySpeed: 2000,
      speed: 500,
      arrows: false,
      dots: false,
      pauseOnHover: false,
      responsive: [
        {
          breakpoint: 1024,
          settings: { slidesToShow: 4 },
        },
        {
          breakpoint: 768,
          settings: { slidesToShow: 3 },
        },
        {
          breakpoint: 480,
          settings: { slidesToShow: 2 },
        },
      ],
    });

  // Product page price change code end here
  // homepage banner slider code start here
  $('.slick-slider-home').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });

  // Home page review slider code start here
  $('.review-slider-home').slick({
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    dots: true,
    infinite: true,
    // centerMode: true,
    speed: 500,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });

  // Initialize the slider for the initially active tab
  $('.tab-slider-home').slick({
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          arrows: false,
          dots: true,
        },
      },
    ],
  });

  if ($(window).width() > 767) {
    // Shop By Collection code start here
    $('.feature-collection-slider').slick({
      infinite: true,
      slidesToShow: 4,
      slidesToScroll: 1,
      arrows: false,
      dots: false,
      infinite: true,
      // centerMode: true,
      speed: 500,
    });
  }

  // Related Product Mobile slider code start here
  $('.related_mobile_slider').slick({
    infinite: true,
    slidesToShow: 2,
    slidesToScroll: 1,
    arrows: false,
    dots: true,
  });
});
